// نطاق فرع المحاسبة — مصدر واحد للحقيقة عبر localStorage + بثّ حدث للتحديث.
// كل استدعاء API لـ /accounting يحقن branch_id من هنا تلقائياً عبر Axios interceptor.
const KEY = "acct.branchId";
const EVT = "acct-scope-changed";

export const getAcctBranchId = () => localStorage.getItem(KEY) || "";

export const setAcctBranchId = (value) => {
  const next = value || "";
  const prev = getAcctBranchId();
  if (next === prev) return;
  if (next) localStorage.setItem(KEY, next);
  else localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent(EVT, { detail: next }));
};

export const onAcctScopeChange = (fn) => {
  const handler = (e) => fn(e.detail || "");
  window.addEventListener(EVT, handler);
  return () => window.removeEventListener(EVT, handler);
};
